export enum MissedCallsAnalyticsEvents {
  PageViewed = 'page_viewed',
  AssigneeChanged = 'assignee_chngd',
}
